import { render, staticRenderFns } from "./CalendarEventSmall.vue?vue&type=template&id=1ac8ecfe&scoped=true"
import script from "./CalendarEventSmall.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventSmall.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarEventSmall.vue?vue&type=style&index=0&id=1ac8ecfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac8ecfe",
  null
  
)

export default component.exports